module.exports = __webpack_public_path__ + "img/炒瓜蒌子.466362ba.jpg";